<template>
  <div>
    <!-- change quota modal -->
    <Modal
      :isOpen="isQuotaModalOpen && !showPaymentModal && !hideMainModal"
      :changeModalState="toggleChangingQuotaModal"
      size="5xl"
      :modalTitle="modalTitle"
    >
      <!-- shows up when loading -->
      <div v-if="isLoadingProducts" class="modal-loader">
        <div class="lds-dual-ring"></div>
      </div>
      <!-- shows up when loaded -->
      <!-- Modal body -->
      <div v-else class="pt-9 pb-2 px-4 md:px-5 lg:px-6 min-h-[300px]" :style="{ direction: currentLanguage === 'ar' ? 'rtl' : 'ltr' }">
        <!-- base phase - managing user's quota -->
        <div v-if="currentTabIndex == 0" class="pb-10 md:pb-16">
          <div class="text-center">
            <h2
              class="mb-7 md:mb-10 text-[20px] md:text-[24px] lg:text-[28px] font-[600]"
            >{{ $t('panel.selecting_sub_option') }}</h2>

            <div
              :class="`grid gap-6 grid-cols-1 mb-4 w-full mx-auto md:grid-cols-2 xl:grid-cols-2 max-w-[680px]`"
            >
              <!-- upgrade button -->
              <div
                class="border border-gray-200 rounded-md shadow-md overflow-hidden pt-1.5 pb-0 flex flex-col w-full"
              >
                <div
                  class="min-h-[87px] bg-[#fff] flex flex-col w-full justify-center items-center"
                >
                  <svg
                    class="text-green-400 mb-2.5"
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="29"
                    viewBox="0 0 32 32"
                  >
                    <path
                      fill="currentColor"
                      d="M21 24H11a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm0 4H11v-2h10zm7.707-13.707l-12-12a1 1 0 0 0-1.414 0l-12 12A1 1 0 0 0 4 16h5v4a2.002 2.002 0 0 0 2 2h10a2.003 2.003 0 0 0 2-2v-4h5a1 1 0 0 0 .707-1.707zM21 14v6H11v-6H6.414L16 4.414L25.586 14z"
                    />
                  </svg>
                  <strong class="ellipsis-x1">{{ $t('panel.change_quota') }}</strong>
                </div>
                <button
                  class="w-full flex ltr flex-nowrap items-center hover:brightness-95 transition-all duration-150 text-center gap-1.5 font-[500] justify-center text-[18px] md:text-[19px] bg-[#f7f6f6] text-primary bg- py-1.5 border-t border-gray-200"
                  @click="() => setCurrentQuotaOption('upgrade')"
                >
                  <span>{{ $t('general.select_noun') }}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="m359.873 121.377l-22.627 22.627l95.997 95.997H16v32.001h417.24l-95.994 95.994l22.627 22.627L494.498 256L359.873 121.377z"
                    />
                  </svg>
                </button>
              </div>
              <!-- renew button -->
              <div
                class="border border-gray-200 rounded-md shadow-md overflow-hidden pt-1.5 pb-0 flex flex-col w-full"
              >
                <div
                  class="min-h-[87px] bg-[#fff] flex flex-col w-full justify-center items-center"
                >
                  <svg
                    class="text-blue-400 mb-2.5"
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="29"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M12 6v3l4-4l-4-4v3a8 8 0 0 0-8 8c0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.9 5.9 0 0 1 6 12a6 6 0 0 1 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.8.7 2.8a6 6 0 0 1-6 6v-3l-4 4l4 4v-3a8 8 0 0 0 8-8c0-1.57-.46-3.03-1.24-4.26Z"
                    />
                  </svg>
                  <strong class="ellipsis-x1">{{ $t('panel.renew_quota') }}</strong>
                </div>
                <button
                  :disabled="disableTheRenewButton"
                  :class="`${disableTheRenewButton ? 'disabled' : ''} w-full flex flex-nowrap items-center hover:brightness-95 transition-all duration-150 text-center gap-1.5 font-[500] justify-center text-[18px] md:text-[19px] bg-[#f7f6f6] text-primary bg- py-1.5 border-t border-gray-200`"
                  @click="() => setCurrentQuotaOption('renew')"
                >
                  <span>{{ $t('general.select_noun') }}</span>
                </button>
              </div>
              <!-- downgrade button -->
              <!-- <div
                class="border border-gray-200 rounded-md shadow-md overflow-hidden pt-1.5 pb-0 flex flex-col w-full"
              > -->
                <!-- <div
                  class="min-h-[87px] bg-[#fff] flex flex-col w-full justify-center items-center"
                >
                  <svg
                    class="text-red-400 mb-2.5"
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="29"
                    viewBox="0 0 24 24"
                  >
                    <g fill="none">
                      <path
                        fill="currentColor"
                        d="M12.75 4a.75.75 0 0 0-1.5 0h1.5Zm-1.5 0v16h1.5V4h-1.5Z"
                        opacity=".5"
                      />
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                        d="m18 14l-6 6l-6-6"
                      />
                    </g>
                  </svg>
                  <strong class="ellipsis-x1">{{ $t('panel.downgrade_quota') }}</strong>
                </div> -->
                <!-- In case if the user has not downgraded their subscription before -->
                <!-- <button
                  v-if="is_downgraded"
                  class="w-full flex ltr flex-nowrap items-center hover:brightness-95 transition-all duration-150 text-center gap-1.5 font-[500] justify-center text-[18px] md:text-[19px] bg-red-100 text-red-700 bg- py-1.5 border-t border-gray-200"
                  @click="() => setCurrentQuotaOption('cancel_downgrading')"
                >
                  <span>{{ $t('panel.cancel_downgrade_subscription') }}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="m359.873 121.377l-22.627 22.627l95.997 95.997H16v32.001h417.24l-95.994 95.994l22.627 22.627L494.498 256L359.873 121.377z"
                    />
                  </svg>
                </button> -->
                <!-- otherwise -->
                <!-- <button
                  v-else
                  :disabled="packageProductsCount <= productsMaxNumber"
                  :class="`${packageProductsCount <= productsMaxNumber ? 'disabled': ''} w-full flex ltr flex-nowrap items-center hover:brightness-95 transition-all duration-150 text-center gap-1.5 font-[500] justify-center text-[18px] md:text-[19px] bg-[#f7f6f6] text-primary bg- py-1.5 border-t border-gray-200`.trim()"
                  @click="() => setCurrentQuotaOption('downgrade')"
                >
                  <span>{{ $t('general.select_noun') }}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="m359.873 121.377l-22.627 22.627l95.997 95.997H16v32.001h417.24l-95.994 95.994l22.627 22.627L494.498 256L359.873 121.377z"
                    />
                  </svg>
                </button> -->
              <!-- </div> -->
            </div>
            <div class="flex md:grid-cols-2 items-center justify-center gap-2.5">
                  <h5 class="block mb-2.5 mt-4 text-center text-sm text-red-500">
                    {{ $t('general.reduce_package_message') }}
                  </h5>
                  <a v-if="whatsappLink" :href="whatsappLink" target="_blank">
                    <img src="../../assets/icons/whatsapp.svg" alt="whatsapp" class="w-[30px] h-[30px]">
                  </a>
               </div>
          </div>
        </div>
        <div v-else>
          <!-- form wizard steps -->
          <form-wizard
            @on-complete="onComplete"
            @on-change="onStepsIndexChange"
            transition="fade"
            step-size="xs"
            class="ltr"
            :startIndex="1"
            color="#0758E7"
            stepSize="xs"
            ref="wizard"
            nextButtonText="Next"
          >
            <!-- UPGRADE -->
            <div v-if="currentQuotaOption === 'upgrade'">
              <!-- empty tab - when clicked, it takes the user back to the quota options -->
              <tab-content :title="$t('panel.selecting_sub_option')" />
              <!-- phase two - setting a number of products -->
              <tab-content :title="$t('panel.setting_products_count')">
                <div class="w-full md:w-[100%] mb-9 mt-4">
                  <!-- <label
                    for="selectProductsCount"
                    class="block mb-2.5 text-sm md:text-md font-medium text-gray-900"
                  >
                    {{
                    $t('panel.upgrade_products_count')
                    }}
                  </label>
                  <select
                      id="selectProductsCount"
                      v-model.number="currentProductsCount"
                      :autoFocus="true"
                      required
                      :style="{ direction: isRTL ? 'rtl' : 'ltr' }"
                      class="bg-gray-50 border border-gray-300 h-[46px] text-gray-900 text-md rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full rtl:pr-8 rtl:pl-2.5 ltr:pr-2.5">
                      <option value disabled>{{ $t('panel.products_count') }}</option>
                      <option v-for="countOption in productCountOptions" :value="countOption" :key="countOption">{{ countOption }}</option>
                    </select> -->
                    <div v-if="!toPayment" class="mt-[30px] flex gap-[5px] justify-center flex-wrap" :style="{ direction: currentLanguage === 'ar' ? 'rtl' : 'ltr' }">
                      <!-- Loading state while finding active period -->
                      <div v-if="isLoadingActivePeriod" class="w-full text-center p-4">
                        <div class="animate-spin mx-auto w-6 h-6 border-2 border-primary border-t-transparent rounded-full"></div>
                        <p class="mt-2 text-gray-600">{{ $t('general.loading') }}...</p>
                      </div>
                      <!-- Render SetPackages only after active period is determined -->
                      <SetPackages 
                        v-else
                        :type="'upgrade'" 
                        :currentStoreId="currentStoreId" 
                        :currentPackage="currentPackageData" 
                        :initialPeriod="activePeriodId"
                        @packageSelected="onPackageSelected"
                        @changePage="handleChangePage" />
                    </div>
                    <div v-if="toPayment" class="mt-[30px] flex gap-[5px] justify-center flex-wrap w-full" :style="{ direction: currentLanguage === 'ar' ? 'rtl' : 'ltr' }">
                      <PaymentSection :currentStoreId="currentStoreId" :type="'upgrade'" />
                    </div>
                </div>
              </tab-content>
            </div>

            <!-- DOWNGRADE -->
            <div v-if="currentQuotaOption === 'downgrade'">
              <!-- empty tab - when clicked, it takes the user back to the quota options -->
              <tab-content :title="$t('panel.selecting_sub_option')" key="selecting_sub_option" />
              <!-- phase two - setting a number of products -->
              <tab-content :lazy="true" :title="$t('panel.setting_products_count')" key="products_count">
                <div
                  v-if="packageProductsCount >= productsMaxNumber"
                  class="w-full md:w-[50%] mb-9 mt-4"
                >
                  <label
                    for="selectProductsCount"
                    class="block mb-2.5 text-sm md:text-md font-medium text-gray-900"
                  >
                    {{
                    $t('panel.downgrade_products_count')
                    }}
                  </label> 
                  <input
                    v-model.number="currentProductsCount"
                    :autoFocus="true"
                    type="number"
                    id="selectProductsCount"
                    :min="1"
                    :max="(+packageProductsCount - productsMaxNumber)"
                    class="bg-gray-50 border border-gray-300 h-[46px] text-gray-900 text-md rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-0.5 px-2.5"
                    required
                    @input="onDowngradeProductsCountChange"
                  />
                </div>
                <p v-else class="text-red-600 mt-1 mb-2">{{ $t('panel.reached_products_limit') }}</p>
                <p v-if="continueSelectingProductsToDowngrade" class="text-blue-500 text-[13px] mt-6 mb-2">
                  <!-- multiple products to remove hint -->
                  <span v-if="productsCountToDelete > 1">
                    {{ $t('panel.select_products_to_downgrade_hint_pt1') }}
                      <strong>{{ productsCountToDelete }}</strong>
                    {{ $t('panel.select_products_to_downgrade_hint_pt2') }}
                  </span>
                   <!--single product to remove hint -->
                  <span v-else>{{ $t('panel.select_products_to_downgrade_hint') }}</span>
                </p>
              </tab-content>
              <!-- phase three - selecting what products to be downgraded -->
              <div >
                <tab-content v-if="continueSelectingProductsToDowngrade" :lazy="true" key="selecting_products_to_downgrade" :title="$t('panel.selecting_products_to_downgrade')">
                  <div class="mb-9 mt-7">
                    <div class="w-full md:w-[50%]">
                      <label
                        for="selectProductsCount"
                        class="block mb-2.5 text-sm md:text-md font-medium text-gray-900"
                      >
                        {{ $t('general.select') }}
                        <span v-if="productsCountToDelete > 1">
                          {{ $t('general.the') }}
                          <strong>{{ productsCountToDelete }}</strong>
                          {{ $t('general.products') }}
                        </span>
                        <span v-else>{{ $t('general.product_noun') }}</span>
                        {{ productsCountToDelete > 1 ? $t('panel.products_you_want_to_downgrade') : $t('panel.product_you_want_to_downgrade') }}
                      </label>
                      <!-- search products -->
                      <form class="mb-8" @submit.prevent="filterProducts">
                        <label
                          for="default-search"
                          class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                        >{{ $t('general.search') }}</label>
                        <div class="relative">
                          <div
                            class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                          >
                            <svg
                              class="w-4 h-4 text-gray-500 dark:text-gray-400"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 20 20"
                            >
                              <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                              />
                            </svg>
                          </div>
                          <input
                            type="search"
                            v-model.trim="searchWord"
                            id="default-search"
                            class="block w-full h-[46px] py-0.5 pr-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            :placeholder="$t('panel.search_for_product')"
                          />
                          <button
                            type="submit"
                            class="text-white absolute right-2 top-[50%] translate-y-[-50%] bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                          >{{ $t('general.search') }}</button>
                        </div>
                      </form>
                    </div>

                    <!-- products list -->
                    <h5 class="mb-4">{{ $t('panel.products_list') }} {{selectedProductsToDowngrade ? selectedProductsToDowngrade.length : 0}}/{{productsCountToDelete }}</h5>

                    <ul
                      v-if="filteredProductsList && filteredProductsList.length > 0"
                      class="p-0 list-none w-full md:w-[70%] overflow-y-auto overflow-x-hidden max-h-[300px]"
                    >
                      <li
                        v-for="product in filteredProductsList"
                        :key="product.id"
                        :class="
                              `${
                                hasFinishedSelectingDowngradedProducts && !selectedProductsToDowngrade.some((item) => item === product.id) ? 'disabled' : ''
                              } flex bg-primary/5 rounded mb-1 py-2 px-2 sm:py-2.5 sm:px-3 lg:px-4 items-center justify-between`.trim()
                            "
                      >
                        <div class="flex flex-nowrap items-center gap-1 md:gap-2">
                          <img
                            width="30"
                            height="30"
                            class="w-[20px] h-[20px] sm:w-[30px] sm:h-[30px] rounded-md object-contain"
                            :src="product.image || (product.images && product.images.length > 0 ? product.images[0] : '')"
                            :alt="product[this.nameKey]"
                          />
                          <span class="ellipsis-x1">{{ product[this.nameKey] }}</span>
                        </div>
                        <div class="flex flex-wrap items-center gap-1.5 sm:gap-2.5">
                          <div>
                            <strong
                              class="text-[#000000] font-bold"
                            >{{ arabizeNumbers(Number(product.price).toLocaleString()) }}</strong>
                            <span class="text-[#717171] mx-0.5">{{ $t('general.egy_pounds') }}</span>
                          </div>
                          <input
                            type="checkbox"
                            name="downgradeProducts"
                            :disabled="hasFinishedSelectingDowngradedProducts && !selectedProductsToDowngrade.some((item) => item === product.id)"
                            :checked="selectedProductsToDowngrade.some((item) => item === product.id)"
                            @change="(e) => toggleProductSelection({ id: product.id, isChecked: e.target.checked })"
                          />
                        </div>
                      </li>
                    </ul>
                    <div v-else class="mt-5">{{ $t('panel.empty_prodducts') }}</div>
                  </div>
                </tab-content>
              </div>
            </div>
            <!-- customized finish button -->
            <template v-slot:finish>
              <button
                v-if="currentQuotaOption !== 'upgrade' && !isUpdatingSubscription && ((currentQuotaOption === 'downgrade' )
                        ? ( (packageProductsCount >= productsMaxNumber) && productsList && (continueSelectingProductsToDowngrade ? ((selectedProductsToDowngrade.length >= 1) &&
                          selectedProductsToDowngrade.length == productsCountToDelete) : true) ) : true)"
                aria-label="Complete subscription"
                class="wizard-btn"
                tabindex="-1"
                type="button"
                style="background-color: rgb(7, 88, 231); border-color: rgb(7, 88, 231); color: white"
              >{{ currentQuotaOption === 'upgrade' ? $t('general.get_quota') : $t('general.complete') }}</button>
              <span v-else></span>
            </template>
            <!-- customized next button -->
            <template v-slot:next>
              <button
                v-if="!isUpdatingSubscription && ((currentQuotaOption === 'downgrade' && productsList)
                        ? ( packageProductsCount >= productsMaxNumber ) : true)"
                aria-label="Go next"
                class="wizard-btn"
                tabindex="-1"
                type="button"
                style="background-color: rgb(7, 88, 231); border-color: rgb(7, 88, 231); color: white"
              >{{ $t('general.next') }}</button>
              <span v-else></span>
            </template>
            <!-- customized back button -->
            <template v-slot:prev>
              <button
                class="border border-gray-300 bg-white/90 min-h-[36px] rounded-lg min-w-[140px] px-[12px] py-[6px] font-[600] text-[14px]"
                aria-label="Go back"
                tabindex="-1"
                type="button"
              >{{ $t('general.back') }}</button>
            </template>
          </form-wizard>
        </div>
      </div>
    </Modal>
    <!-- subscription confirmation dialog -->
    <div id="customConfirmationDialog" v-if="isSubscriptionConfirmationOpen && !showPaymentModal && !hideMainModal">
      <div
        @click="() => closePackagesDialog()"
        :class="`modal-backdrop ${isSubscriptionConfirmationOpen ? '' : 'hidden'}`"
      ></div>
      <div id="popupModal" tabindex="-1">
        <div class="fixed modal-inner z-[200] w-[95.5%] max-w-md max-h-full">
          <div class="relative bg-white rounded-lg modal_inner_dialog">
            <button
              @click="() => closePackagesDialog()"
              type="button"
              class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>

            <!-- modal content -->
            <div class="p-6 text-center">
              <svg
                aria-hidden="true"
                class="mx-auto mb-4 text-gray-400 w-14 h-14"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <h3 class="mb-5 text-lg font-normal text-gray-500">
                {{ $t(`panel.${currentQuotaOption}_subscription_confirmation`) }}
                <span
                  v-if="currentQuotaOption === 'downgrade'"
                >
                    {{ ' ' }}
                    <span v-if="continueSelectingProductsToDowngrade && productsCountToDelete">
                        {{ $t('panel.and_delete') }}
                        <strong>{{ productsCountToDelete }}</strong>
                        {{ $t('general.items') }} 
                      </span>
                    {{ $t('general.will_be_activated_when_quota_gets_renewed') }}. {{ $t('general.confirm_question') }}
                  </span>
              </h3>
              <div class="flex justify-center items-center gap-2">
                <button
                  :disabled="isUpdatingSubscription"
                  @click="() => onConfirmSelection()"
                  type="button"
                  :class="`${isUpdatingSubscription ? 'disabled' : ''} ${
                        currentQuotaOption !== 'downgrade'
                          ? 'text-dark bg-primaryLighter/90 text-white hover:bg-primary focus:ring-4 focus:outline-none focus:ring-primary/20 font-medium rounded-lg text-sm px-5 py-2 text-center'
                          : 'text-primary bg-white hover:bg-gray-100 hover:text-gray-900 border border-gray-200 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2'
                      }`"
                >{{ $t('general.yes') }}</button>
                <button
                  :disabled="isUpdatingSubscription"
                  @click="() => closePackagesDialog()"
                  type="button"
                  :class="`${
                        isUpdatingSubscription ? 'disabled' : ''
                      } text-primary bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10`"
                >{{ $t('general.no') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- product selection modal for downgrade -->
    <Teleport to="body">
      <transition name="modal-fade">
        <div 
          v-if="showProductSelectionModal && !showPaymentModal" 
          id="productSelectionDialog" 
          class="fixed inset-0 z-[10000] flex items-center justify-center p-4"
          style="backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px);"
        >
          <!-- Enhanced backdrop with blur -->
          <div
            @click="closeProductSelectionModal"
            class="absolute inset-0 bg-black/70 backdrop-blur-sm transition-opacity duration-300"
          ></div>
          
          <!-- Modal container with animation -->
          <transition name="modal-scale">
            <div 
              v-if="showProductSelectionModal"
              id="productSelectionPopupModal" 
              tabindex="-1" 
              class="relative z-[10001] w-full max-w-2xl max-h-[90vh] transform transition-all duration-300"
              @click.stop
            >
              <div class="modal-inner w-full max-h-full overflow-y-auto">
                <div class="relative bg-white rounded-xl shadow-2xl border-2 border-gray-300 modal_inner_dialog" style="box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 0, 0, 0.1);">
                  <button
                    @click="closeProductSelectionModal"
                    type="button"
                    class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                  >
                    <svg
                      aria-hidden="true"
                      class="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="sr-only">Close modal</span>
                  </button>

                  <!-- modal content -->
                  <div class="p-6 md:p-8" :style="{ direction: currentLanguage === 'ar' ? 'rtl' : 'ltr' }">
                    <!-- Icon and Title -->
                    <div class="text-center mb-6">
                      <div class="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                        <svg
                          aria-hidden="true"
                          class="text-orange-500 w-8 h-8"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                          />
                        </svg>
                      </div>
                      <h3 class="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                        {{ $t('panel.select_products_to_delete_title') }}
                      </h3>
                      <p class="text-sm md:text-base text-gray-600">
                        <span v-if="productsCountToDeleteForUpgrade > 1">
                          {{ $t('panel.need_to_delete_products_plural') }}
                          <strong class="text-orange-600 font-semibold">{{ productsCountToDeleteForUpgrade }}</strong>
                          {{ $t('panel.products_to_downgrade') }}
                        </span>
                        <span v-else>
                          {{ $t('panel.need_to_delete_product_singular') }}
                          <strong class="text-orange-600 font-semibold">1</strong>
                          {{ $t('panel.product_to_downgrade') }}
                        </span>
                      </p>
                    </div>

                    <!-- Progress Indicator -->
                    <div class="mb-6">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-gray-700">
                          {{ $t('panel.products_list') }}
                        </span>
                        <span class="text-sm font-semibold" :class="isProductSelectionComplete ? 'text-green-600' : 'text-orange-600'">
                          {{ productsToDeleteForDowngrade.length }} / {{ productsCountToDeleteForUpgrade }}
                        </span>
                      </div>
                      <div class="w-full bg-gray-200 rounded-full h-2.5">
                        <div 
                          class="h-2.5 rounded-full transition-all duration-300"
                          :class="isProductSelectionComplete ? 'bg-green-500' : 'bg-orange-500'"
                          :style="{ width: `${Math.min((productsToDeleteForDowngrade.length / productsCountToDeleteForUpgrade) * 100, 100)}%` }"
                        ></div>
                      </div>
                    </div>
                    
                    <!-- Search products -->
                    <div class="mb-4">
                      <label
                        for="product-selection-search"
                        class="mb-2 text-sm font-medium text-gray-900 sr-only"
                      >{{ $t('general.search') }}</label>
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none"
                        >
                          <svg
                            class="w-5 h-5 text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <path
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                            />
                          </svg>
                        </div>
                        <input
                          type="search"
                          v-model.trim="searchWordForProductSelection"
                          @input="filterProductsForSelection"
                          id="product-selection-search"
                          class="block w-full h-[48px] py-2.5 pr-4 pl-12 text-sm text-gray-900 border-2 border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-primary focus:border-primary transition-all"
                          :placeholder="$t('panel.search_for_product')"
                        />
                        <button
                          v-if="searchWordForProductSelection"
                          @click="searchWordForProductSelection = ''; filterProductsForSelection()"
                          type="button"
                          class="absolute inset-y-0 right-2 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                        >
                          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <!-- Products list -->
                    <div class="border-2 border-gray-200 rounded-lg overflow-hidden bg-gray-50">
                      <div 
                        v-if="filteredProductsListForSelection && filteredProductsListForSelection.length > 0"
                        class="max-h-[400px] overflow-y-auto"
                      >
                        <div
                          v-for="product in filteredProductsListForSelection"
                          :key="product.id"
                          @click="handleProductCardClick(product, $event)"
                          :class="`${
                            isProductSelectionComplete && !productsToDeleteForDowngrade.some((item) => item === product.id) 
                              ? 'opacity-50 cursor-not-allowed' 
                              : 'hover:bg-white cursor-pointer active:bg-gray-100'
                          } flex items-center gap-3 p-3 border-b border-gray-200 last:border-b-0 transition-all select-none`.trim()"
                        >
                          <div class="flex-shrink-0" @click.stop>
                            <input
                              type="checkbox"
                              name="downgradeProductsForUpgrade"
                              :disabled="isProductSelectionComplete && !productsToDeleteForDowngrade.some((item) => item === product.id)"
                              :checked="productsToDeleteForDowngrade.some((item) => item === product.id)"
                              @change="(e) => toggleProductSelectionForDowngrade({ id: product.id, isChecked: e.target.checked })"
                              @click.stop
                              class="w-5 h-5 text-primary bg-white border-2 border-gray-300 rounded focus:ring-2 focus:ring-primary focus:ring-offset-2 cursor-pointer disabled:cursor-not-allowed"
                            />
                          </div>
                          <div class="flex-shrink-0">
                            <img
                              width="50"
                              height="50"
                              class="w-12 h-12 sm:w-14 sm:h-14 rounded-lg object-cover border-2 border-gray-200"
                              :src="product.image || (product.images && product.images.length > 0 ? product.images[0] : '/assets/images/placeholder_doNotRemove_.webp')"
                              :alt="product[this.nameKey]"
                              @error="$event.target.src = '/assets/images/placeholder_doNotRemove_.webp'"
                            />
                          </div>
                          <div class="flex-1 min-w-0">
                            <h4 class="text-sm md:text-base font-semibold text-gray-900 mb-1 truncate">
                              {{ product[this.nameKey] }}
                            </h4>
                            <div class="flex items-center gap-2">
                              <span class="text-base md:text-lg font-bold text-gray-900">
                                {{ arabizeNumbers(Number(product.price).toLocaleString()) }}
                              </span>
                              <span class="text-sm text-gray-500">{{ $t('general.egy_pounds') }}</span>
                            </div>
                          </div>
                          <div 
                            v-if="productsToDeleteForDowngrade.some((item) => item === product.id)"
                            class="flex-shrink-0"
                          >
                            <div class="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                              <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="p-8 text-center">
                        <svg class="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                        </svg>
                        <p class="text-gray-500 text-sm md:text-base">{{ $t('panel.empty_prodducts') }}</p>
                        <p v-if="searchWordForProductSelection" class="text-gray-400 text-xs mt-2">
                          {{ $t('general.no_results_found') }}
                        </p>
                      </div>
                    </div>

                    <!-- Validation message -->
                    <div v-if="productsToDeleteForDowngrade.length > 0 && !isProductSelectionComplete" class="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                      <p class="text-sm text-yellow-800 text-center">
                        <span v-if="productsCountToDeleteForUpgrade > 1">
                          {{ $t('panel.please_select_more_products', { count: productsCountToDeleteForUpgrade - productsToDeleteForDowngrade.length }) }}
                        </span>
                        <span v-else>
                          {{ $t('panel.please_select_one_more_product') }}
                        </span>
                      </p>
                    </div>
                    
                    <!-- Action buttons -->
                    <div class="flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-3 mt-6 pt-6 border-t border-gray-200">
                      <button
                        @click="closeProductSelectionModal"
                        type="button"
                        class="order-2 sm:order-1 px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border-2 border-gray-300 rounded-lg hover:bg-gray-50 focus:ring-4 focus:outline-none focus:ring-gray-200 transition-all"
                      >
                        {{ $t('general.cancel') }}
                      </button>
                      <button
                        @click="confirmProductSelection"
                        :disabled="!isProductSelectionComplete"
                        type="button"
                        :class="`order-1 sm:order-2 px-6 py-2.5 text-sm font-semibold rounded-lg focus:ring-4 focus:outline-none transition-all ${
                          isProductSelectionComplete 
                            ? 'text-white bg-primary hover:bg-primary/90 focus:ring-primary/20 shadow-lg shadow-primary/20' 
                            : 'text-gray-400 bg-gray-200 cursor-not-allowed'
                        }`"
                      >
                        <span v-if="isProductSelectionComplete">
                          {{ $t('general.continue') }}
                        </span>
                        <span v-else>
                          {{ $t('panel.select_products_first') }}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </Teleport>
    <!-- downgrade duration confirmation modal -->
    <Teleport to="body">
      <transition name="modal-fade">
        <div 
          v-if="showDowngradeConfirmationModal && !showPaymentModal" 
          id="downgradeConfirmationDialog" 
          class="fixed inset-0 z-[10000] flex items-center justify-center p-4"
          style="backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px);"
        >
          <!-- Enhanced backdrop with blur -->
          <div
            @click="closeDowngradeConfirmationModal"
            class="absolute inset-0 bg-black/70 backdrop-blur-sm transition-opacity duration-300"
          ></div>
          
          <!-- Modal container with animation -->
          <transition name="modal-scale">
            <div 
              v-if="showDowngradeConfirmationModal"
              id="popupModal" 
              tabindex="-1" 
              class="relative z-[10001] w-full max-w-lg max-h-[90vh] transform transition-all duration-300"
              @click.stop
            >
              <div class="modal-inner w-full max-h-full overflow-y-auto">
                <div class="relative bg-white rounded-xl shadow-2xl border-2 border-gray-300 modal_inner_dialog" style="box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 0, 0, 0.1);">
            <button
              @click="closeDowngradeConfirmationModal"
              type="button"
              class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>

            <!-- modal content -->
            <div class="p-6" :style="{ direction: currentLanguage === 'ar' ? 'rtl' : 'ltr' }">
              <svg
                aria-hidden="true"
                class="mx-auto mb-4 text-yellow-400 w-14 h-14"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <h3 class="mb-5 text-lg font-semibold text-gray-900 text-center">
                {{ $t('panel.downgrade_duration_confirmation_title') }}
              </h3>
              
              <div class="mb-5 text-sm text-gray-600 space-y-3">
                <p class="text-center">
                  {{ $t('panel.are_you_sure_downgrade_from') }}
                  <strong>{{ oldPackagePeriodText }}</strong>
                  {{ $t('panel.to') }}
                  <strong>{{ newPackagePeriodText }}</strong>
                </p>
                
                <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
                  <p class="text-blue-800 text-sm mb-2">
                    <strong>{{ $t('panel.important_notice') }}:</strong>
                  </p>
                  <ul class="list-disc list-inside space-y-1 text-blue-700 text-sm">
                    <li>{{ $t('panel.subscription_will_apply_after_current_ends') }}</li>
                    <li v-if="computedExpiryDate">
                      {{ $t('panel.current_subscription_ends_on') }}: <strong>{{ computedExpiryDate }}</strong>
                    </li>
                    <li>{{ $t('panel.price_will_change_from') }} 
                      <strong>{{ Number(Math.abs(package_price)) }} {{ $t('general.egy_pounds') }}</strong>
                      {{ $t('panel.to') }}
                      <strong>{{ Number(Math.abs(selectedPackageData?.price)) || Number(Math.abs(selectedPackageData?.packageData?.price)) }} {{ $t('general.egy_pounds') }}</strong>
                    </li>
                  </ul>
                </div>
              </div>
              
              <div class="flex justify-center items-center gap-3 mt-6">
                <button
                  @click="closeDowngradeConfirmationModal"
                  type="button"
                  class="text-gray-700 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-300 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
                >{{ $t('general.cancel') }}</button>
                <button
                  @click="confirmDowngrade"
                  type="button"
                  class="text-white bg-primary hover:bg-primary/90 focus:ring-4 focus:outline-none focus:ring-primary/20 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >{{ $t('general.yes') }}</button>
              </div>
            </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </transition>
    </Teleport>
    <!-- payment modal -->
    <div
      class="fixed z-[200] inset-0 h-screen w-full bg-[#2b2b2b8e]"
      id="payment-modal"
      v-if="showPaymentModal"
      @click="(e) => { e.target.id == 'payment-modal' ? closePaymentModal(): '' }"
    >
      <transition name="dropdown">
        <!-- modal contnet-->
        <div
          class="flex flex-col gap-8 px-3 py-3 fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[120] overflow-hidden rounded-lg bg-gray-200 w-[90%] sm:w-full max-w-[400px]"
          style
        >
          <h1
            autofocus="false"
            aria-selected="false"
            class="w-full sm:w-[70%] border-b-2 border-[#000000] text-[#000000] text-center py-2 px-1 mx-auto font-extrabold [font-size:_clamp(.7em,2vw,1em)]"
          >{{ $t('general.choose_payment_method') }}</h1>
          <section class="mt-5 grid gap-6">
            <!-- card -->
            <div class="relative">
              <input
                v-model="paymentMethod"
                value="card"
                class="peer hidden"
                id="radio_1"
                type="radio"
                name="radio"
                checked
              />
              <label
                class="peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50 flex cursor-pointer select-none rounded-lg border border-gray-400 p-4"
                for="radio_1"
              >
                <img class="w-14 object-contain" src="@/assets/upgrade/visa.png" alt />
                <div class="mr-5 ltr:mr-0 ltr:ml-5">
                  <span
                    class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]"
                  >{{ $t('general.by') }}</span>
                  <p class="text-slate-500 text-sm leading-6">Visa</p>
                </div>
              </label>
            </div>
            <!-- Mobile wallet -->
            <div class="relative">
              <input
                v-model="paymentMethod"
                value="mobile_wallet"
                class="peer hidden"
                id="radio_2"
                type="radio"
                name="radio"
              />
              <label
                class="peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50 flex cursor-pointer select-none rounded-lg border border-gray-400 p-4"
                for="radio_2"
              >
                <img class="w-14 object-contain" src="@/assets/upgrade/wallet.png" alt />
                <div class="mr-5 ltr:mr-0 ltr:ml-5">
                  <span
                    class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]"
                  >{{ $t('general.by') }}</span>
                  <p class="text-slate-500 text-sm leading-6 py-2">Mobile wallet</p>
                </div>
              </label>
            </div>
            <!-- Credit wallet -->
            <div class="relative">
                <input v-model="paymentMethod" value="credit_wallet" class="peer hidden" id="radio_3" type="radio" name="radio" />
                <label
                  class="peer-checked:border-2 peer-checked:border-[#4f55f2] peer-checked:bg-gray-50 flex cursor-pointer select-none rounded-lg border border-gray-400 p-4"
                  for="radio_3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="56px" height="56px" viewBox="0 0 48 48"><g fill="none"><rect width="38" height="26" x="5" y="13" fill="#2f88ff" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" rx="2"/><rect width="18" height="11" x="25" y="20" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M43 18L43 33"/><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M32 13C32 8 28.5 7 27 7C23.6667 7 16.1 7 12.5 7C8.9 7 8 9.86567 8 11.2985V13"/><circle cx="33.5" cy="25.5" r="1.5" fill="#fff"/></g></svg>
                  <div class="mr-5 ltr:mr-0 ltr:ml-5">
                    <span class="mt-2 font-semibold [font-size:_clamp(.7em,2vw,1em)]">{{ $t('general.by') }}</span>
                    <p class="text-slate-500 text-sm leading-6 py-2">Cezma wallet</p>
                  </div>
                </label>
            </div>
            <!-- phone -->
            <div v-if="paymentMethod=='mobile_wallet'">
              <input
                v-model="phone"
                maxlength="11"
                type="tel"
                @input="(e) => phone = (e.target.value).replace(/\D/g, '')"
                :class="` mt-2 bg-[#FFFFFF] w-full ${v$.phone.$errors.length ? 'border-[#ed0d0d]' : 'border-[#D8D8D8]'} outline-none placeholder:text-[#bebebe] border text-gray-900 rounded-[7px] focus:border-blue-500 text-sm block pr-3 p-2.5`"
                :placeholder="$t('user.store.phone_number')"
              />
              <p
                v-for="(error, index) of v$.phone.$errors"
                :key="error.uid"
                class="text-sm text-red-600 pr-2 ltr:pr-0 ltr:pl-2 mt-1"
              >{{ index == 0 ? error.$message : '' }}</p>
            </div>
          </section>

          <section
            class="flex flex-row justify-around text-white font-semibold [font-size:_clamp(.7em,2vw,.9em)]"
          >
            <button
              @click="confirmSelectedSubscription()"
              :disabled="isUpdatingSubscription"
              class="bg-[#0963FF] py-2 px-1 w-[80%] sm:w-[40%] text-center rounded-md hover:bg-blue-700 focus:ring-4 disabled:bg-blue-900 focus:outline-none focus:ring-blue-200 dark:focus:ring-blue-900"
            >{{isUpdatingSubscription ? $t("general.loading"): ` ➔ ${$t('general.continue_payment')}`}}</button>
            <!-- <button class="bg-[#0963FF] py-2 px-1 w-[30%] text-center rounded-md">تخطي الكل</button> -->
          </section>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { Modal } from "@/components";
import { lowerString } from "@/helpers";
import { FormWizard, TabContent } from "vue3-form-wizard";
import "vue3-form-wizard/dist/style.css";
import { useVuelidate } from "@vuelidate/core";
import SetPackages from "@/components/generic/Upgrade/SetPackages.vue";
import PaymentSection from '~/components/generic/Upgrade/PaymentSection.vue';
import { useGlobalStore } from "~/store/Modules/global";
import { generateWhatsappLink } from "@/helpers";
export default {
  data() {
    return {
      v$: useVuelidate(),
      currentTabIndex: 0,
      isUpdatingSubscription: false,
      currentQuotaOption: null,
      showPaymentModal: false,
      isSubscriptionConfirmationOpen: false,
      searchWord: "",
      filteredProductsList: [],
      currentLanguage: useGlobalStore()?.localStorageCopy?.language || "ar",
      currentProductsCount: 1,
      productsCountToDelete: 0,
      productsMaxNumber: 100,
      selectedProductsToDowngrade: [],
      paymentMethod: "card", //mobile_wallet
      phone: "",
      productCountOptions: [
        50,
        100,
        150,
        200,
        250,
        300,
        350,
        400,
        450,
        500
      ],
      toPayment: false,
      activePeriodId: 1, // Default to period 1
      isLoadingActivePeriod: false, // Loading state for finding active period
      pendingAutoPaymentFlow: false,
      selectedPackageData: null, // Store selected package data
      showDowngradeConfirmationModal: false, // Control downgrade confirmation modal
      showProductSelectionModal: false, // Control product selection modal for downgrade
      productsToDeleteForDowngrade: [], // Stores selected product IDs to delete
      newPackageProductsCount: null, // Stores the new package's products_count for comparison
      productsCountToDeleteForUpgrade: 0, // Number of products to delete for upgrade flow
      searchWordForProductSelection: "", // Search word for product selection modal
      filteredProductsListForSelection: [], // Filtered products list for product selection modal
    };
  },
  components: {
    Modal,
    FormWizard,
    TabContent,
    SetPackages,
    PaymentSection
  },
  props: {
    isQuotaModalOpen: {
      type: Boolean,
      required: true,
      default: false
    },
    toggleChangingQuotaModal: {
      type: Function,
      required: true
    },
    isLoadingProducts: {
      type: Boolean,
      required: true,
      default: false
    },
    updateData: {
      type: Function,
      required: true
    },
    is_downgraded: {
      type: Boolean,
      required: true,
      default: false
    },
    package_price: {
      type: [String, Number],
      required: true,
      default: "0"
    },
    packageProductsCount: {
      type: [String, Number],
      required: true,
      default: "0"
    },
    receivedProductsCount: {
      type: [String, Number],
      required: true,
      default: "0"
    },
    productsList: {
      type: Array,
      required: true,
      default: () => []
    },
    currentStoreId: {
      type: [String, Number],
      required: true,
      default: ""
    },
    whatsappLink: {
      type: String,
      required: false,
      default: null
    },
    hideMainModal: {
      type: Boolean,
      required: false,
      default: false
    },
    expiryDate: {
      type: String,
      required: false,
      default: null
    },
    currentPackageInfo: {
      type: Object,
      required: false,
      default: null
    }
  },
  validations() {
    return { phone: { ...this.VALIDATIONS.phone } };
  },
  computed: {
    ...mapState(useGlobalStore, ['layout']),
    roleType() {
      // Get roleType from localStorage (user.role or admin.role)
      // This ensures it works when opened from reminder notification on index page
      try {
        const user = this.useLocalStorage({ type: 'get', key: 'user' }) || {};
        const admin = this.useLocalStorage({ type: 'get', key: 'admin' }) || {};
        // For reseller/moderator_reseller, check admin first (set by handelControlPanel), then user
        const role = admin?.role || user?.role || '';
        if (!role) {
          console.warn('ChangePackageModal: roleType not found in localStorage');
        }
        return role;
      } catch (error) {
        console.error('ChangePackageModal: Error getting roleType', error);
        return '';
      }
    },
    disableTheRenewButton() {
      // Allow renew when opened from reminder notification (hideMainModal) 
      // or when currentQuotaOption is renew, as renewal price comes from API
      if (this.hideMainModal || this.currentQuotaOption === 'renew') {
        return false;
      }
      return +this.package_price == 0;
    },
    hasFinishedSelectingDowngradedProducts() {
      return (
        this.selectedProductsToDowngrade?.length === this.productsCountToDelete
      );
    },
    continueSelectingProductsToDowngrade(){
      const remainingProductsCount = (+this.packageProductsCount - this.receivedProductsCount);
      return this.currentProductsCount > remainingProductsCount;
    },
    modalTitle(){
      return this.currentTabIndex !== 0 ? (this.currentQuotaOption === 'upgrade' ? this.$t('panel.upgrade_quota') : this.currentQuotaOption === 'downgrade' ? this.$t('panel.downgrade_quota') : this.$t('panel.change_current_quota')) : this.$t('panel.change_current_quota');
    },
    currentPackageData(){
      // Return current package data for auto-selection in SetPackages
      return {
        products_count: this.packageProductsCount,
        price: this.package_price,
        is_current: true,
        months_period: this.activePeriodId, // Include the found active period
        expiry_date: this.computedExpiryDate, // Include expiry date
      };
    },
    computedExpiryDate(){
      // Get expiry date from prop or from currentPackageInfo
      return this.expiryDate || this.currentPackageInfo?.expiry_date || this.currentPackageInfo?.expiration_date || null;
    },
    currentPackageMonthsPeriod(){
      // Get months_period from currentPackageInfo if available
      if (this.currentPackageInfo?.package?.months_period) {
        return parseInt(this.currentPackageInfo.package.months_period);
      }
      return null;
    },
    isDowngradeDuration(){
      // Check if selected package has lower duration than current package
      if (!this.selectedPackageData || !this.activePeriodId) return false;
      const newPeriod = parseInt(this.selectedPackageData.months_period || this.selectedPackageData.period || this.selectedPackageData.packageData?.months_period || 0);
      const currentPeriod = parseInt(this.activePeriodId || 0);
      if (!newPeriod || !currentPeriod) return false;
      return newPeriod < currentPeriod;
    },
    oldPackagePeriodText(){
      // Get period text for old package
      const period = this.activePeriodId;
      if (period === 1) return this.$t('user.upgrade.per_month');
      if (period === 3) return this.$t('user.upgrade.per_3_month');
      if (period === 6) return this.$t('user.upgrade.per_6_month');
      if (period === 12) return this.$t('user.upgrade.per_12_month');
      return `${period} ${this.$t('user.upgrade.months')}`;
    },
    newPackagePeriodText(){
      // Get period text for new package
      if (!this.selectedPackageData) return '';
      const period = this.selectedPackageData.months_period || this.selectedPackageData.period;
      if (period === 1) return this.$t('user.upgrade.per_month');
      if (period === 3) return this.$t('user.upgrade.per_3_month');
      if (period === 6) return this.$t('user.upgrade.per_6_month');
      if (period === 12) return this.$t('user.upgrade.per_12_month');
      return `${period} ${this.$t('user.upgrade.months')}`;
    },
    isProductSelectionComplete(){
      // Check if correct number of products is selected
      return this.productsToDeleteForDowngrade.length === this.productsCountToDeleteForUpgrade && this.productsCountToDeleteForUpgrade > 0;
    },
  },
  methods: {
    closePaymentModal() {
      this.showPaymentModal = false;
      (this.phone = ""), (this.paymentMethod = "card");
      this.v$.$reset();
    },
    filterProducts() {
      let { productsList, searchWord } = this;
      if (!searchWord) {
        this.filteredProductsList = this.productsList || [];
      } else {
        this.filteredProductsList =
          productsList?.length > 0
            ? productsList.filter(product => {
                searchWord = lowerString(searchWord);
                const enName = lowerString(product.name_en);
                const arName = lowerString(product.name_ar);
                return (
                  enName?.includes(searchWord) || arName?.includes(searchWord)
                );
              })
            : [];
      }
    },
    onStepsIndexChange(prevIndex, nextIndex) {
      this.currentTabIndex = nextIndex;
      if (prevIndex > nextIndex) {
        if (nextIndex !== 1) {
          this.currentProductsCount = 1;
        }
        this.selectedProductsToDowngrade = [];
      }
    },
    closePackagesDialog() {
      if (this.isUpdatingSubscription) {
        return;
      }
      this.isSubscriptionConfirmationOpen = false;
    },
    onConfirmSelection() {
      if (
        this.currentQuotaOption === "downgrade" ||
        this.currentQuotaOption === "cancel_downgrading"
      ) {
        if (this.currentQuotaOption === "downgrade"||
          (this.continueSelectingProductsToDowngrade ? (this.selectedProductsToDowngrade?.length < 1 ||
          this.selectedProductsToDowngrade?.length !== this.productsCountToDelete) : !this.currentProductsCount)) {
          return;
        }
        this.confirmSelectedSubscription();
      } else {
        this.showPaymentModal = true;
      }
      this.closePackagesDialog();
    },
    confirmSelectedSubscription() {
      console.log('confirmSelectedSubscription', this.currentStoreId, this.roleType, this.currentQuotaOption, this.currentProductsCount, this.paymentMethod, this.phone);
      if (!this.currentStoreId) {
        console.error('ChangePackageModal: currentStoreId is missing');
        this.notify({
          type: 'error',
          msg: this.$t('general.failed')
        });
        return;
      }

      if (!this.roleType) {
        console.error('ChangePackageModal: roleType is missing');
        this.notify({
          type: 'error',
          msg: this.$t('general.failed')
        });
        return;
      }

      switch (lowerString(this.currentQuotaOption)) {
        case "upgrade":
          if (this.currentProductsCount < 1) return;
          //payment logic
          this.paymentMethod == "mobile_wallet" && this.v$.$touch();
          if (this.paymentMethod == "mobile_wallet" && this.v$.phone.$error)
            return;
          this.isUpdatingSubscription = true;
          // Get package ID and products_count from selectedPackageData if available
          const packageId = this.selectedPackageData?.packageId || this.selectedPackageData?.packageData?.id || null;
          const selectedPackageProductsCount = this.selectedPackageData?.packageData?.products_count || this.selectedPackageData?.products_count || null;
          // Use package products_count if available, otherwise fall back to currentProductsCount
          const productsCountToUse = selectedPackageProductsCount ? +selectedPackageProductsCount : +this.currentProductsCount;
          this.makeRequest({
            specificRole: this.roleType,
            owner: this.MAINROLES.admin,
            formData: {
              store_id: this.currentStoreId,
              products_count: productsCountToUse,
              payment_method: this.paymentMethod,
              ...(packageId && { package_id: packageId }),
              ...(this.paymentMethod == "mobile_wallet" && {
                phone: this.phone
              }),
              ...(this.productsToDeleteForDowngrade.length > 0 && {
                products_ids: this.productsToDeleteForDowngrade
              })
            },
            method: this.APIREQUESTS.reseller.upgradeSubscription.method,
            url: this.APIREQUESTS.reseller.upgradeSubscription.url
          })
            .then(res => {
              this.isUpdatingSubscription = false;
              // failed
              if (!res || !res?.hasOwnProperty("status")) {
                return;
              } else if (!res?.status) {
                this.notify({
                  type: "error",
                  msg: res.message
                });
              } else {
                if(this.paymentMethod == 'credit_wallet'){
                  this.notify({ type: 'success', msg: this.$t('general.payment_is_done_successfully') });
                }else{
                  // succeeded
                  // const admin=this.useLocalStorage({ type: 'get', key: 'admin' });
                  // this.fawryCheckout({
                  //     merchantRefNum : res?.data?.id,
                  //     price : res?.data?.price ,
                  //     customerMobile:admin?.phone,
                  //     customerEmail:admin?.email,
                  //     customerName:admin?.first_name,
                  //     returnUrl:`${window.location.origin}${this.ROUTESNAMES.payment.state}/admin`
                  // })
                  this.useLocalStorage({
                    type: "set",
                    key: "payment_type",
                    value: "upgrade"
                  });
                  window.open(res?.data?.payment_url, "_blank");
                }

                this.toggleChangingQuotaModal(false);
                this.updateData({});
              }
            })
            .catch(err => {
              this.notify({
                type: "error",
                msg: this.$t("general.unknown_error")
              });
              this.isUpdatingSubscription = false;
            })
            .finally(() => {
              this.closePaymentModal();
            });
          break;
        case "downgrade":
          if (
            this.currentProductsCount < 1 ||
            (this.continueSelectingProductsToDowngrade ? (this.selectedProductsToDowngrade.length < 1 ||
            this.selectedProductsToDowngrade.length >
              this.receivedProductsCount ||
            this.selectedProductsToDowngrade.length > this.productsCountToDelete) : !this.currentProductsCount)
          ) {
            return;
          }
          this.isUpdatingSubscription = true;
          this.makeRequest({
            specificRole: this.roleType,
            owner: this.MAINROLES.admin,
            formData: {
              store_id: this.currentStoreId,
              products_count: +this.currentProductsCount,
              ...((this.continueSelectingProductsToDowngrade && this.productsCountToDelete) && {
                products_ids: this.selectedProductsToDowngrade
              })
            },
            method: this.APIREQUESTS.reseller.downgradeSubscription.method,
            url: this.APIREQUESTS.reseller.downgradeSubscription.url
          })
            .then(res => {
              this.isUpdatingSubscription = false;
              // failed
              if (!res || !res?.hasOwnProperty("status")) {
                return;
              } else if (!res?.status) {
                this.notify({
                  type: "error",
                  msg: res.message
                });
              } else {
                // succeeded
                this.notify({
                  type: "success",
                  msg: res.message
                });
                this.toggleChangingQuotaModal(false);
                this.updateData({});
              }
            })
            .catch(err => {
              this.notify({
                type: "error",
                msg: this.$t("general.unknown_error")
              });
              this.isUpdatingSubscription = false;
            });
          break;
        case "renew":
          // Allow renew even if package_price is 0 when opened from reminder
          // The renewal price will be fetched from the API
          if (this.disableTheRenewButton && !this.hideMainModal) {
            console.error('ChangePackageModal: Renew button is disabled, package_price:', this.package_price);
            this.notify({
              type: "error",
              msg: this.$t('general.failed')
            });
            return;
          }
          
          //payment logic
          this.paymentMethod == "mobile_wallet" && this.v$.$touch();
          if (this.paymentMethod == "mobile_wallet" && this.v$.phone.$error) {
            console.error('ChangePackageModal: Phone validation failed');
            return;
          }
          
          // Verify required dependencies are available
          if (!this.makeRequest) {
            console.error('ChangePackageModal: makeRequest method is not available');
            this.notify({
              type: "error",
              msg: this.$t("general.unknown_error")
            });
            return;
          }
          
          if (!this.MAINROLES || !this.APIREQUESTS) {
            console.error('ChangePackageModal: MAINROLES or APIREQUESTS not available', {
              MAINROLES: this.MAINROLES,
              APIREQUESTS: this.APIREQUESTS
            });
            this.notify({
              type: "error",
              msg: this.$t("general.unknown_error")
            });
            return;
          }
          
          console.log('ChangePackageModal: Making renew request with:', {
            specificRole: this.roleType,
            owner: this.MAINROLES.admin,
            store_id: this.currentStoreId,
            payment_method: this.paymentMethod,
            url: this.APIREQUESTS.reseller.renewSubscription.url,
            method: this.APIREQUESTS.reseller.renewSubscription.method
          });
          
          this.isUpdatingSubscription = true;
          this.makeRequest({
            specificRole: this.roleType,
            owner: this.MAINROLES.admin,
            formData: {
              store_id: this.currentStoreId,
              payment_method: this.paymentMethod,
              ...(this.paymentMethod == "mobile_wallet" && {
                phone: this.phone
              })
            },
            method: this.APIREQUESTS.reseller.renewSubscription.method,
            url: this.APIREQUESTS.reseller.renewSubscription.url
          })
            .then(res => {
              console.log('ChangePackageModal: Renew request response:', res);
              this.isUpdatingSubscription = false;
              // failed
              if (!res || !res?.hasOwnProperty("status")) {
                console.error('ChangePackageModal: Invalid response structure:', res);
                this.notify({
                  type: "error",
                  msg: res?.message || this.$t("general.unknown_error")
                });
                return;
              } else if (!res?.status) {
                console.error('ChangePackageModal: Renew request failed:', res.message);
                this.notify({
                  type: "error",
                  msg: res.message || this.$t("general.failed")
                });
              } else {
                if(this.paymentMethod == 'credit_wallet'){
                  this.notify({ type: 'success', msg: this.$t('general.payment_is_done_successfully') });
                }else{
                  // succeeded
                  // const admin=this.useLocalStorage({ type: 'get', key: 'admin'});
                  // this.fawryCheckout({
                  //   merchantRefNum : res?.data?.id,
                  //   price : res?.data?.price ,
                  //   customerMobile:admin?.phone,
                  //   customerEmail:admin?.email,
                  //   customerName:admin?.first_name,
                  //   returnUrl:`${window.location.origin}${this.ROUTESNAMES.payment.state}/admin`
                  // })
                  this.useLocalStorage({
                    type: "set",
                    key: "payment_type",
                    value: "renew"
                  });
                  window.open(res?.data?.payment_url, "_blank");

                  this.toggleChangingQuotaModal(false);
                  this.updateData({});
                }
              }
            })
            .catch(err => {
              console.error('ChangePackageModal: Renew request error:', err);
              console.error('ChangePackageModal: Error details:', {
                message: err?.message,
                response: err?.response,
                data: err?.data,
                status: err?.status
              });
              this.notify({
                type: "error",
                msg: err?.data?.message || err?.message || this.$t("general.unknown_error")
              });
              this.isUpdatingSubscription = false;
            })
            .finally(() => {
              this.closePaymentModal();
            });
          break;
        case "cancel_downgrading":
          this.isUpdatingSubscription = true;
          this.makeRequest({
            specificRole: this.roleType,
            owner: this.MAINROLES.admin,
            formData: {
              store_id: this.currentStoreId
            },
            method: this.APIREQUESTS.reseller.cancelSubscription.method,
            url: this.APIREQUESTS.reseller.cancelSubscription.url
          })
            .then(res => {
              this.isUpdatingSubscription = false;
              // failed
              if (!res || !res?.hasOwnProperty("status")) {
                return;
              } else if (!res?.status) {
                this.notify({
                  type: "error",
                  msg: res.message
                });
              } else {
                // succeeded
                this.notify({
                  type: "success",
                  msg: res.message
                });
                this.toggleChangingQuotaModal(false);
                this.updateData({});
              }
            })
            .catch(err => {
              this.notify({
                type: "error",
                msg: this.$t("general.unknown_error")
              });
              this.isUpdatingSubscription = false;
            });
          break;
        default:
          () => {};
      }
    },
    onComplete() {
      switch (lowerString(this.currentQuotaOption)) {
        case "upgrade":
          this.isSubscriptionConfirmationOpen = true;
          break;
        case "downgrade":
          this.isSubscriptionConfirmationOpen = true;
          break;
        default:
          () => {};
      }
    },
    toggleProductSelection({ id, isChecked }) {
      if (isChecked) {
        const newIdsList = [
          ...new Set([...this.selectedProductsToDowngrade, id])
        ];
        this.selectedProductsToDowngrade = newIdsList;
      } else {
        const productIndex = this.selectedProductsToDowngrade
          ?.map(product => product)
          .indexOf(id);
        if (productIndex !== -1) {
          this.selectedProductsToDowngrade.splice(productIndex, 1);
        }
      }
    },
    onDowngradeProductsCountChange(e){
      const val = e.target.value;
      // const maxNum = (+this.packageProductsCount - this.productsMaxNumber);
      // if( val > maxNum ){
      //   this.currentProductsCount = maxNum;
      // }
      if(this.continueSelectingProductsToDowngrade){
        const remainingProductsCount = (+this.packageProductsCount - this.receivedProductsCount);
        this.productsCountToDelete = (val - remainingProductsCount);
      }
    },
    removeThirdTab(){
      this.$nextTick(() => {
        if (this.currentQuotaOption !== 'downgrade') {
          return;
        }
        // force removing the third tab as a workaround because it doesn't get removed if the v-if condition is false
        // it has to do with the vue3-form-wizard package
        const tabs = this.$refs?.wizard?.tabs;
        if(tabs?.length >= 3){
          this.$refs.wizard.tabs.pop();
        }
      });
    },
    setCurrentQuotaOption(currentOption) {
      currentOption = lowerString(currentOption);
      this.currentQuotaOption = currentOption;
      switch (currentOption) {
        case "upgrade":
          this.currentTabIndex = 1;
          this.currentProductsCount = 50;
          break;
        case "downgrade":
          this.currentTabIndex = 1;
          this.currentProductsCount = 1;
          break;
        case "renew":
        case "cancel_downgrading":
          this.isSubscriptionConfirmationOpen = true;
          break;
        default:
          () => {};
      }
    },
    startRenewPaymentFlow() {
      this.pendingAutoPaymentFlow = true;
      this.setCurrentQuotaOption("renew");
      this.$nextTick(() => {
        if (this.pendingAutoPaymentFlow && this.currentQuotaOption === "renew") {
          this.onConfirmSelection();
        }
        this.pendingAutoPaymentFlow = false;
      });
    },
    onPackageSelected(packageData) {
      console.log('🔍 onPackageSelected called with:', packageData);
      // Store selected package data
      this.selectedPackageData = packageData;
      
      // Use nextTick to ensure data is set before checking
      this.$nextTick(() => {
        // Check if this is a downgrade before proceeding
        const newPeriod = parseInt(packageData.months_period || packageData.period || packageData.packageData?.months_period || 0);
        const currentPeriod = parseInt(this.activePeriodId || 0);
        
        // Validate both periods are valid numbers
        if (!newPeriod || !currentPeriod) {
          console.warn('⚠️ Invalid period values:', { newPeriod, currentPeriod, activePeriodId: this.activePeriodId });
          // If we can't determine, proceed to payment
          this.toPayment = true;
          return;
        }
        
        const isDowngrade = newPeriod < currentPeriod;
        
        // Get new package products count
        const newPackageProductsCount = parseInt(
          packageData.packageData?.products_count || 
          packageData.products_count || 
          0
        );
        
        // Get current products count from productsList length
        const currentProductsCount = this.productsList?.length || 0;
        
        // Check if products exceed the new package limit
        const productsExceedLimit = currentProductsCount > newPackageProductsCount && newPackageProductsCount > 0;
        
        console.log('📊 Downgrade check:', {
          newPeriod,
          currentPeriod,
          isDowngrade,
          currentProductsCount,
          newPackageProductsCount,
          productsExceedLimit,
          activePeriodId: this.activePeriodId,
          packageData: packageData
        });
        
        if (isDowngrade && productsExceedLimit) {
          // Store new package products count
          this.newPackageProductsCount = newPackageProductsCount;
          // Calculate products to delete
          this.productsCountToDeleteForUpgrade = currentProductsCount - newPackageProductsCount;
          // Initialize filtered products list
          this.filteredProductsListForSelection = this.productsList || [];
          // Reset selections
          this.productsToDeleteForDowngrade = [];
          this.searchWordForProductSelection = "";
          console.log('⚠️ Showing product selection modal (products exceed limit)');
          // Show product selection modal FIRST
          this.showProductSelectionModal = true;
        } else if (isDowngrade) {
          console.log('⚠️ Showing downgrade confirmation modal (no products to delete)');
          // Show downgrade confirmation modal directly
          this.showDowngradeConfirmationModal = true;
        } else {
          console.log('✅ No downgrade, proceeding to payment');
          // Otherwise proceed normally to payment
          this.toPayment = true;
        }
      });
    },
    handleChangePage(){
      // This is called as fallback if SetPackages emits changePage
      // If we already handled via packageSelected, don't do anything
      if (this.selectedPackageData) {
        // Already handled in onPackageSelected
        return;
      }
      // Otherwise proceed normally (backward compatibility)
      this.toPayment = true;
    },
    changePage(){
      // Legacy method - keep for backward compatibility
      this.handleChangePage();
    },
    closeDowngradeConfirmationModal() {
      this.showDowngradeConfirmationModal = false;
      this.selectedPackageData = null;
    },
    confirmDowngrade() {
      // Close confirmation modal and proceed to payment
      // Note: productsToDeleteForDowngrade is already set from product selection modal
      // It will be included in the API request in confirmSelectedSubscription
      this.showDowngradeConfirmationModal = false;
      this.toPayment = true;
    },
    closeProductSelectionModal() {
      // Close modal and reset selections
      this.showProductSelectionModal = false;
      this.productsToDeleteForDowngrade = [];
      this.searchWordForProductSelection = "";
      this.selectedPackageData = null;
    },
    confirmProductSelection() {
      // Validate that correct number of products is selected
      if (!this.isProductSelectionComplete) {
        return;
      }
      // Close product selection modal
      this.showProductSelectionModal = false;
      // Show duration confirmation modal
      this.showDowngradeConfirmationModal = true;
    },
    handleProductCardClick(product, event) {
      // Don't allow selection if disabled
      if (this.isProductSelectionComplete && !this.productsToDeleteForDowngrade.some((item) => item === product.id)) {
        return;
      }
      
      // Toggle selection
      const isCurrentlySelected = this.productsToDeleteForDowngrade.some((item) => item === product.id);
      this.toggleProductSelectionForDowngrade({ id: product.id, isChecked: !isCurrentlySelected });
    },
    toggleProductSelectionForDowngrade({ id, isChecked }) {
      if (isChecked) {
        // Add product if not already selected and we haven't reached the limit
        if (this.productsToDeleteForDowngrade.length < this.productsCountToDeleteForUpgrade) {
          const newIdsList = [
            ...new Set([...this.productsToDeleteForDowngrade, id])
          ];
          this.productsToDeleteForDowngrade = newIdsList;
        }
      } else {
        // Remove product
        const productIndex = this.productsToDeleteForDowngrade.indexOf(id);
        if (productIndex !== -1) {
          this.productsToDeleteForDowngrade.splice(productIndex, 1);
        }
      }
    },
    filterProductsForSelection() {
      let { productsList, searchWordForProductSelection } = this;
      if (!searchWordForProductSelection || searchWordForProductSelection.trim() === '') {
        this.filteredProductsListForSelection = this.productsList || [];
      } else {
        this.filteredProductsListForSelection =
          productsList?.length > 0
            ? productsList.filter(product => {
                const searchWord = lowerString(searchWordForProductSelection.trim());
                const enName = lowerString(product.name_en || '');
                const arName = lowerString(product.name_ar || '');
                return (
                  enName?.includes(searchWord) || arName?.includes(searchWord)
                );
              })
            : [];
      }
    },
    
    async findActivePeriodAndLoad(quotaOption) {
      if (!this.currentStoreId) return;
      
      console.log(`Finding active period for ${quotaOption} change`);
      this.isLoadingActivePeriod = true;
      
      // First, check if we can get months_period from currentPackageInfo
      const storePackagePeriod = this.currentPackageMonthsPeriod;
      if (storePackagePeriod) {
        console.log(`Using months_period from store object: ${storePackagePeriod}`);
        this.activePeriodId = storePackagePeriod;
        this.isLoadingActivePeriod = false;
        return;
      }
      
      try {
        // Load packages for all periods to find the active one
        const periodList = [1, 3, 6, 12]; // Available period options
        const requests = periodList.map(periodId => {
          let url = '';
          
          if (quotaOption === 'upgrade') {
            url = `${this.APIREQUESTS.panel.getPackages.url}?months_period=${periodId}&change_type=${quotaOption}&store_id=${this.currentStoreId}`;
          } else if (quotaOption === 'downgrade') {
            url = `${this.APIREQUESTS.panel.getPackages.url}?months_period=${periodId}&change_type=${quotaOption}&store_id=${this.currentStoreId}`;
          } else if (quotaOption === 'renew') {
            url = `${this.APIREQUESTS.panel.getPackages.url}?months_period=${periodId}&change_type=renew&store_id=${this.currentStoreId}`;
          } else {
            url = `${this.APIREQUESTS.panel.getPackages.url}?months_period=${periodId}`;
          }
          
          return this.makeRequest({
            owner: this.MAINROLES.user,
            url: url,
            method: this.APIREQUESTS.panel.getPackages.method,
          });
        });

        const responses = await Promise.all(requests);
        
        // Process responses to find packages with is_current
        let activePeriodId = null;
        
        responses.forEach((res, index) => {
          if (res && res.hasOwnProperty('status') && res.status) {
            const periodId = periodList[index];
            const packages = res.data || [];
            
            console.log(`Checking period ${periodId} packages:`, packages);
            
            // Check if this period has an active package
            const hasActivePackage = packages.some(pkg => {
              const isActive = pkg.is_current || pkg.isActive;
              console.log(`Package ${pkg.id}: is_current=${pkg.is_current}, isActive=${pkg.isActive}`, pkg);
              return isActive;
            });
            
            if (hasActivePackage) {
              activePeriodId = periodId;
              console.log('Found active package in period:', periodId);
            }
          }
        });
        
        if (activePeriodId) {
          console.log('Setting active period to:', activePeriodId);
          this.activePeriodId = activePeriodId;
        } else {
          console.log('No active period found, keeping default period 1');
          this.activePeriodId = 1;
        }
        
      } catch (err) {
        console.error('Error finding active period:', err);
        this.activePeriodId = 1; // Fallback to period 1
        this.notify({ type: 'error', msg: err?.data?.message || this.$t("general.unknown_error") });
      } finally {
        this.isLoadingActivePeriod = false;
      }
    }
  },
  watch: {
    productsList: {
      immediate: true,
      handler(newList) {
        this.filteredProductsList = newList;
        // Also initialize filteredProductsListForSelection
        this.filteredProductsListForSelection = newList || [];
      }
    },
    isQuotaModalOpen: {
      handler(isOpen) {
        if (isOpen && this.productsList && this.productsList.length > 0) {
          // Initialize filtered products list when modal opens
          this.filteredProductsListForSelection = this.productsList;
        }
      },
      immediate: true
    },
    continueSelectingProductsToDowngrade:{
      handler(val){
        if(typeof val == 'boolean' && !val){
          this.removeThirdTab();
        }
      }
    },
    currentQuotaOption: {
      async handler(newOption, oldOption) {
        console.log('🔄 ChangePackageModal: Quota option changed from', oldOption, 'to', newOption);
        console.log('🔄 Active period ID before:', this.activePeriodId);
        if (newOption && (newOption === 'upgrade' || newOption === 'renew')) {
          await this.findActivePeriodAndLoad(newOption);
          console.log('🔄 Active period ID after:', this.activePeriodId);
        }
      },
      immediate: false
    },
    currentPackageInfo: {
      handler(newInfo) {
        // Update active period when currentPackageInfo changes
        if (newInfo && this.currentPackageMonthsPeriod) {
          console.log('📦 Updating active period from currentPackageInfo:', this.currentPackageMonthsPeriod);
          this.activePeriodId = this.currentPackageMonthsPeriod;
        }
      },
      immediate: true
    }
  },
  
  
  beforeDestroy() {
    this.currentTabIndex = 0;
  }
};
</script>

<style scoped>
/* Modal fade transition */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

/* Modal scale transition */
.modal-scale-enter-active {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-scale-leave-active {
  transition: all 0.2s ease-in;
}

.modal-scale-enter-from {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

.modal-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.modal-scale-enter-to,
.modal-scale-leave-from {
  opacity: 1;
  transform: scale(1) translateY(0);
}

/* Ensure modal appears above everything */
#downgradeConfirmationDialog {
  z-index: 10000 !important;
}

#popupModal {
  z-index: 10001 !important;
}

/* Enhanced backdrop */
#downgradeConfirmationDialog .modal-backdrop {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* Smooth scrollbar for modal content */
.modal-inner::-webkit-scrollbar {
  width: 6px;
}

.modal-inner::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modal-inner::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.modal-inner::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>